import PostHogBillableUsageTemplate from "../../../../contents/docs/_snippets/posthog-billable-usage-template.mdx";
import * as React from 'react';
export default {
  PostHogBillableUsageTemplate,
  React
};